import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import PageSubHeader from '../../components/common/page_sub_header'
import PerfectScrollbar from 'react-perfect-scrollbar'
import TableHeaderBetting from '../../components/control/table/table_header_betting'
import TableCell from '../../components/control/table/table_cell'
import TableCellBettingResult from '../../components/control/table/table_cell_betting_result'
import {ceil, chkNoteTitle, customDateFormat, formatNumber, string} from '../../helper/common'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {API_URL} from '../../config/const'
import CKEditor from '@ckeditor/ckeditor5-react'
import {rootStore} from '../../mobx/store'

const AnalystNewBetting = observer((props) => {
  const data = props?.location?.state?.data || null;
  const context = useContext(Page_settings)
  let priceList = [rootStore.getMe.price5_1, rootStore.getMe.price5_2, rootStore.getMe.price5_3]
  let [title, setTitle] = useState('')
  let [datMode, setDatMode] = useState(1)
  let [content, setContent] = useState('')
  let [content2, setContent2] = useState('')
  let [enabled, setEnabled] = useState(false)

  let [yearList, setYearList] = useState([])
  let [roundList, setRoundList] = useState([])
  let [kindList, setKindList] = useState([])
  let [roundListAll, setRoundListAll] = useState([])
  let [year, setYear] = useState(0)
  let [round, setRound] = useState(0)
  let [kind, setKind] = useState(0)
  let [kind2, setKind2] = useState(0)

  let [selGameCnt, setSelGameCnt] = useState(0)
  let [expectRate, setExpectRate] = useState(1.0)
  let [bettingAmount, setBettingAmount] = useState(100000)
  let [expectCoin, setExpectCoin] = useState(0)
  let [expectGainRate, setExpectGainRate] = useState(0)

  let [isSub, setIsSub] = useState(false)
  let [selGameCnt2, setSelGameCnt2] = useState(0)
  let [expectRate2, setExpectRate2] = useState(1.0)
  let [bettingAmount2, setBettingAmount2] = useState(100000)
  let [expectCoin2, setExpectCoin2] = useState(0)
  let [expectGainRate2, setExpectGainRate2] = useState(0)

  let [bettingDataList, setBettingDataList] = useState([])
  let [bettingDataList2, setBettingDataList2] = useState([])

  let [selListAll, setSelListAll] = useState([])
  let [selListAll2, setSelListAll2] = useState([])

  const tbHeaders = [
    {
      name: strings.number,
      class: 'td-pro-betting-num',
    },
    {
      name: strings.game_date,
      class: 'td-pro-betting-game-date',
    },
    {
      name: strings.league,
      class: 'td-pro-betting-league',
    },
    {
      name: strings.betting_line,
      class: 'td-pro-betting-line',
      is_result: true
    },
    {
      name: strings.remark,
      class: 'td-pro-betting-remark',
    }
  ]

  useEffect(() => {
    if (data) {
      setTitle(data.dat_title)
      setDatMode(parseInt(data.dat_mode))
      if (data.other_purchased == 0) {
        setContent(data.dat_note)
        setContent2(data.dat_note2)
      }
      setYear(data.dat_s_year)
      setIsSub(data.dat_note2 !== '')
      setKind(data.dat_s_kind)
      setKind2(data.dat_s_kind2)
    }
    initPicker()
  }, [])

  useEffect(() => {
    let gameCnt = selListAll.length
    let betting = 1
    for (let i = 0; i < gameCnt; i++) {
      betting *= parseFloat(selListAll[i].sel === 0 ? selListAll[i].home_dividend_rate : selListAll[i].sel === 1 ? selListAll[i].no_odds : selListAll[i].away_dividend_rate)
    }
    betting = parseFloat(ceil(betting))
    let hit_val = parseInt(betting * bettingAmount)
    setSelGameCnt(gameCnt)
    setExpectRate(betting)
    setExpectCoin(hit_val)
    setExpectGainRate(parseInt(betting * 100))
  }, [selListAll, bettingAmount])

  useEffect(() => {
    let gameCnt = selListAll2.length
    let betting = 1
    for (let i = 0; i < gameCnt; i++) {
      betting *= parseFloat(selListAll2[i].sel === 0 ? selListAll2[i].home_dividend_rate : selListAll2[i].sel === 1 ? selListAll2[i].no_odds : selListAll2[i].away_dividend_rate)
    }
    betting = parseFloat(ceil(betting))
    let hit_val = parseInt(betting * bettingAmount2)
    setSelGameCnt2(gameCnt)
    setExpectRate2(betting)
    setExpectCoin2(hit_val)
    setExpectGainRate2(parseInt(betting * 100))
  }, [selListAll2, bettingAmount2])

  useEffect(() => {
    if (data && data.other_purchased == 1) {
      setEnabled(true)
      return
    }
    setEnabled(title !== '' && content !== '' && (!isSub || (isSub && content2 !== '')))
  }, [title, content, content2, isSub])

  const initPicker = () => {
    context.post('data/sport_list', {dat_id: (data && data.other_purchased == 1) ? data.dat_id : 0},
      response => {
        const yearL = response.year
        if (yearL.length === 0) return
        const yearT = data ? data.dat_s_year : yearL[0].year
        const roundL = response.round
        const roundL1 = roundL.filter((item) => {return item.year == yearT})
        if (roundL1.length === 0 || roundL1[0].round.length === 0) return
        const roundT = data ? data.dat_s_round : roundL1[0].round[0].round
        setYear(yearT)
        setYearList(yearL)
        setRoundListAll(roundL)
        setRoundList(roundL1[0].round)
        setRound(roundT)
        const kindL = response.kind
        const kindT = data ? data.dat_s_kind : kindL[0].sk_id
        const kindT2 = data ? data.dat_s_kind2 : kindL[0].sk_id
        setKindList(kindL)
        setKind(kindT)
        setKind2(kindT2)
        initData(yearT, roundT, kindT, 1, true)
        initData(yearT, roundT, kindT2, 0, true)
      }
    )
  }

  const initData = (year, round, kind, type, init = false) => {
    context.post('data/get_toto_list', {year: year, round: round, sport: kind, dat_id: (data && data.other_purchased == 1) ? data.dat_id : 0},
      response => {
        let list = response.list
        if (init && data) {
          context.post('data/game_list', {uid: data.dat_id, type: type},
            res => {
              let game_list = res.game_list
              for (let i = 0; i < list.length; i++) {
                let gameT = game_list.filter((item) => {return item.id === list[i].id})
                if (gameT.length > 0) {
                  if (gameT[0].dg_i_win == 1) {
                    list[i].sel = 0
                  } else if (gameT[0].dg_i_tie == 1) {
                    list[i].sel = 1
                  } else if (gameT[0].dg_i_loss == 1) {
                    list[i].sel = 2
                  } else {
                    list[i].sel = -1
                  }
                }
                let gameS = game_list.filter((item) => {return item.id !== list[i].id && item.home_id === list[i].home_id && item.away_id === list[i].away_id && (item.dg_i_win == 1 || item.dg_i_tie == 1 || item.dg_i_loss == 1)})
                if (gameS.length > 0) list[i].disable = true
              }
              if (type === 1) {
                setBettingDataList(list)
                setBettingAmount(data.dat_price)
                setSelListAll(list.filter((item) => {return item.sel > -1}))
              } else {
                setBettingDataList2(list)
                setBettingAmount2(data.dat_price2)
                setSelListAll2(list.filter((item) => {return item.sel > -1}))
              }
            }
          )
        } else {
          for (let i = 0; i < list.length; i++) {
            let gameT = type === 1 ? selListAll.filter((item) => {return item.id === list[i].id}) : selListAll2.filter((item) => {return item.id === list[i].id})
            list[i].sel = gameT.length > 0 ? gameT[0].sel : -1
            let gameS = type === 1 ? selListAll.filter((item) => {return item.id !== list[i].id && item.home_id === list[i].home_id && item.away_id === list[i].away_id && (item.dg_i_win == 1 || item.dg_i_tie == 1 || item.dg_i_loss == 1)}) : selListAll2.filter((item) => {return item.id !== list[i].id && item.home_id === list[i].home_id && item.away_id === list[i].away_id && (item.dg_i_win == 1 || item.dg_i_tie == 1 || item.dg_i_loss == 1)})
            if (gameS.length > 0) list[i].disable = true
          }
          if (type === 1) {
            setBettingDataList(list)
          } else {
            setBettingDataList2(list)
          }
        }
      }
    )
  }

  const selectYear = (year) => {
    setYear(year)
    const roundL = roundListAll.filter((item) => {return item.year == year})
    if (roundL.length === 0 || roundL[0].round.length === 0) {
      setSelListAll([])
      setSelListAll2([])
      setBettingDataList([])
      setBettingDataList2([])
      return
    }
    const roundT = roundL[0].round[0].round
    setRoundList(roundL[0].round)
    setRound(roundT)
    setSelListAll([])
    setSelListAll2([])
    initData(year, roundT, kind, 1)
    initData(year, roundT, kind2, 0)
  }

  const selectRound = (round) => {
    setRound(round)
    setSelListAll([])
    setSelListAll2([])
    initData(year, round, kind, 1)
    initData(year, round, kind2, 0)
  }

  const onSelChange = (val, index, type) => {
    if (data && data.other_purchased == 1) return
    const betting = type === 0 ? bettingDataList[index] : bettingDataList2[index]
    if (betting.disable) return
    const dis_select = betting.sel === val
    if (type === 0) {
      setBettingDataList(prev => prev.map((it, idx) => {
        if (it.home_id === betting.home_id && it.away_id === betting.away_id && idx !== index) {
          it.disable = !dis_select
        }
        if (idx === index) {
          it.sel = it.sel === val ? -1 : val
          if (it.sel > -1) {
            const itemT = selListAll.filter((item) => {return item.id == it.id})
            if (itemT.length === 0) {
              setSelListAll(prev => [...prev, it])
            } else {
              setSelListAll(prev => prev.map((tt) => {
                if (tt.id == it.id) tt.sel = it.sel
                return tt
              }))
            }
          } else {
            setSelListAll(prev => prev.filter((item) => {return item.id != it.id}))
          }
        }
        return it
      }))
    } else {
      setBettingDataList2(prev => prev.map((it, idx) => {
        if (it.home_id === betting.home_id && it.away_id === betting.away_id && idx !== index) {
          it.disable = it.disable = !dis_select
        }
        if (idx === index) {
          it.sel = it.sel === val ? -1 : val
          if (it.sel > -1) {
            const itemT = selListAll2.filter((item) => {return item.id == it.id})
            if (itemT.length === 0) {
              setSelListAll2(prev => [...prev, it])
            } else {
              setSelListAll2(prev => prev.map((tt) => {
                if (tt.id == it.id) tt.sel = it.sel
                return tt
              }))
            }
          } else {
            setSelListAll2(prev => prev.filter((item) => {return item.id != it.id}))
          }
        }
        return it
      }))
    }
  }

  const updateBetting = (value, type) => {
    if (type === 0) {
      setBettingAmount(value.replaceAll(',', ''))
    } else {
      setBettingAmount2(value.replaceAll(',', ''))
    }
  }

  const handleTitle = (e) => {
    setTitle(chkNoteTitle(e))
  }

  const onReset = (type) => {
    if (data && data.other_purchased == 1) return
    if (type === 0) {
      setBettingDataList(prev => prev.map((it, idx) => {
        it.sel = -1
        it.disable = false
        return it
      }))
      setSelListAll([])
    } else {
      setBettingDataList2(prev => prev.map((it, idx) => {
        it.sel = -1
        it.disable = false
        return it
      }))
      setSelListAll2([])
    }
  }

  const changeSub = (sub) => {
    if (data && data.other_purchased == 1) return
    setIsSub(sub)
    if (sub) {
      setBettingAmount(70000)
      setBettingAmount2(30000)
    } else {
      setBettingAmount(100000)
      setBettingAmount2(0)
      onReset(1)
    }
  }

  const onSave = () => {
    if (!enabled) return
    if (data && data.other_purchased == 1) {
      context.post('data/an_new', {uid: data.dat_id, cate: 2, title: title, content: data.dat_note + content, content2: isSub ? data.dat_note2 + content2 : '', modify: 1},
        () => {
          context.showAlert(strings.bj_data_modified, function () {
            props.history.replace('/my_data')
          }, strings.confirm)
        },
        true,
        err => {
          context.showAlert(err.msg)
        }
      )
      return
    }
    let price = parseInt(bettingAmount)
    let price2 = isSub ? parseInt(bettingAmount2) : 0
    if (price === 0 || (isSub && price2 === 0)) {
      context.showAlert(strings.betting_amount_err)
      return
    }
    if ((price + price2) > 100000 || (price + price2) < 1000) {
      context.showAlert(strings.betting_amount_invalid)
      return
    }
    if ((price % 1000) > 0 || (price2 % 1000) > 0) {
      context.showAlert(strings.betting_amount_thousand)
      return
    }
    if (selListAll.length === 0 || (isSub && selListAll2.length === 0)) {
      context.showAlert(strings.select_data)
      return
    }
    let list = []
    let list2 = []
    let start = ''
    let bae = 1
    for (let i = 0; i < selListAll.length; i++) {
      let item = selListAll[i]
      if (start === '' || start > item.round_end) start = item.round_end
      bae *= parseFloat(item.sel === 0 ? item.home_dividend_rate : item.sel === 1 ? item.no_odds : item.away_dividend_rate)
      list.push({id: item.id, kind: item.sport_id, win: item.sel === 0 ? 1 : 0, tie: item.sel === 1 ? 1 : 0, loss: item.sel === 2 ? 1 : 0})
    }
    bae = ceil(bae)
    let bae2 = 1
    for (let i = 0; i < selListAll2.length; i++) {
      let item = selListAll2[i]
      if (start === '' || start > item.round_end) start = item.round_end
      bae2 *= parseFloat(item.sel === 0 ? item.home_dividend_rate : item.sel === 1 ? item.no_odds : item.away_dividend_rate)
      list2.push({id: item.id, kind: item.sport_id, win: item.sel === 0 ? 1 : 0, tie: item.sel === 1 ? 1 : 0, loss: item.sel === 2 ? 1 : 0})
    }
    bae2 = isSub ? ceil(bae2) : 0
    context.post('data/an_new', {uid: data ? data.dat_id : 0, cate: 2, dat_mode: datMode, title: title, content: content, content2: isSub ? content2 : '', price: price, price2: price2, year: year, round: round, kind: kind, kind2: isSub ? kind2 : 0, game: JSON.stringify(list), game2: JSON.stringify(list2), start: start, bae: bae, bae2: bae2},
      () => {
        context.showAlert(data ? strings.bj_data_modified : strings.bj_data_registered, function () {
          props.history.replace('/my_data')
        }, strings.confirm)
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <div className='im-container im-container-no-sidebar'>
          <PageSubHeader pageName={strings.proto_betting} pageMenu1={strings.main} pageMenu2={strings.my_analyst} pageMenu={strings.proto_betting_register}/>
          <div className='al-header mt-30 sm-mt-15 fs-18 sm-fs-16 f-b'>{strings.analyst_article}</div>
          <div className='al-content'>
            <label className='control-label'>{strings.option}</label>
            <select disabled={data && data.other_purchased == 1} className='form-control select-betting' value={datMode} onChange={(e) => { setDatMode(e.target.value)}}>
              <option value={1}>{strings.mode_victory1}[{formatNumber(priceList[0]) + strings.point}]</option>
              <option value={2}>{strings.mode_victory2}[{formatNumber(priceList[1]) + strings.point}]</option>
              <option value={3}>{strings.mode_victory3}[{formatNumber(priceList[2]) + strings.point}]</option>
            </select>
            <label className='control-label mt-20'>{strings.title}<span className='text-danger'>*</span></label>
            <AppInput disable={data && data.other_purchased == 1} className={''} errorMsg={''} placeholder={strings.title_hint} inputType={'text'} value={title} onChange={handleTitle} />
          </div>
          <div className='al-header mt-12 sm-mt-15 fs-18 sm-fs-16 f-b'>{strings.power}</div>
          <div className='al-content al-content-betting'>
            <label className='control-label sm-ph-15'>{strings.analyst_content}<span className='text-danger'>*</span></label>
            {(data && data.other_purchased == 1) && <div className='bj-note mb-20 fs-16 sm-fs-14' dangerouslySetInnerHTML={{ __html: data.dat_note }} />}
            <div className={'sm-ph-15'}>
              <CKEditor
                editor={ClassicEditor}
                data={content}
                config={{
                  ckfinder: {
                    uploadUrl: API_URL + '/api/upload/upload_file'
                  },
                  removePlugins: ['ImageUpload', 'ImageEditing', 'ImageCaption'],
                  placeholder: strings.data_new_input
                }}
                onChange={(event, editor) => {
                  setContent(editor.getData())
                }}
              />
            </div>
            <div className={'data-filter-area d-flex mt-12 sm-mt-15 pl-40 sm-pl-18'}>
              <select disabled={data && data.other_purchased == 1} className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={year} onChange={(e) => {selectYear(e.target.value)}}>
                {yearList.map((it, idx) => {return (<option value={it.year} key={idx}>{it.year}{strings.year}</option>)})}
              </select>
              <select disabled={data && data.other_purchased == 1} className='data-filter-select mh-60 sm-mh-12 pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={round} onChange={(e) => {selectRound(e.target.value)}}>
                {roundList.map((it, idx) => {return (<option value={it.round} key={idx}>{it.round}{strings.times}</option>)})}
              </select>
              <select disabled={data && data.other_purchased == 1} className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={kind} onChange={(e) => {setKind(e.target.value); initData(year, round, e.target.value, 1)}}>
                {kindList.map((it, idx) => {return (<option value={it.sk_id} key={idx}>{it.sk_name}</option>)})}
              </select>
            </div>
            <div className='analyst_register bd-0 pt-20 sm-pt-40 sm-ph-15'>
              <div className='shadow-div position-relative'>
                <PerfectScrollbar className='div_sale div_game'>
                  <TableHeaderBetting className={''} headers={tbHeaders}/>
                  {
                    bettingDataList.map((info, index) => {
                      return (
                        <div key={index} className={'tb-row-betting tb-row-betting1' + (info.disable ? ' tb-row-disabled' : '')}>
                          <TableCell
                            value={info.btm_match_seq}
                            className={tbHeaders[0].class + ' td-cell-primary'}
                            center={tbHeaders[0].center}
                            child={null}
                          />
                          <TableCell
                            value={customDateFormat(info.round_start)}
                            className={tbHeaders[1].class + ' td-cell-primary'}
                            center={tbHeaders[1].center}
                            child={null}
                          />
                          <TableCell
                            value={info.league_name}
                            className={tbHeaders[2].class + ' td-cell-primary'}
                            center={tbHeaders[2].center}
                            child={null}
                          />
                          <TableCellBettingResult
                            betting_type={info.betting_type}
                            home={info.home_name}
                            away={info.away_name}
                            winScore={info.home_dividend_rate}
                            winUp={ info.prev_home_dividend_rate }
                            loseScore={info.away_dividend_rate}
                            loseUp={ info.prev_away_dividend_rate }
                            drawScore={info.no_odds}
                            drawUp={info.prev_no_odds}
                            handi={info.handicap_standard}
                            uo={info.uo_standard}
                            selected={info.sel}
                            ans={-1}
                            className={tbHeaders[3].class + ' td-cell-primary'}
                            center={tbHeaders[3].center}
                            child={null}
                            onSelectChange={(val) => {
                              onSelChange(val, index, 0)
                            }}
                          />
                          <TableCell
                            value={''}
                            className={tbHeaders[4].class + ' td-cell-primary'}
                            center={tbHeaders[4].center}
                            child={null}
                          />
                        </div>
                      )
                    })
                  }
                </PerfectScrollbar>
              </div>
              <div className='div-betting-info d-flex-block pv-48 sm-pv-20 ph-20 sm-ph-30 align-items-center'>
                <div className='d-block flex-full'>
                  <div className='flex-full d-center'>
                    <div className='fs-16 sm-fs-14 f-sb color-3a3335'>{strings.selected_game_count}</div>
                    <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_game_count, selGameCnt)}</div>
                  </div>
                  <div className='flex-full d-center mt-8'>
                    <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_rate}</div>
                    <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_rate, expectRate)}</div>
                  </div>
                </div>
                <div className='d-block flex-full pl-70 sm-pl-0 sm-mt-30'>
                  <div className='flex-full f-sb d-flex align-items-center'>
                    <div className='fs-16 sm-fs-14 color-3a3335 flex-full'>{strings.betting_amount}</div>
                    <AppInput disable={data && data.other_purchased == 1} center={true} className={'betting-price-input fs-16 sm-fs-14'} errorMsg={''} placeholder={'10,000'} inputType={'text'} value={bettingAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} onChange={(v) => { updateBetting(v, 0) }} />
                    <div className='fs-16 sm-fs-14 f-b color-e45a5a pl-12'>{strings.won}</div>
                  </div>
                  <div className='flex-full d-center mt-8 sm-mt-5'>
                    <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_amount}</div>
                    <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_won, formatNumber(expectCoin))}</div>
                  </div>
                </div>
                <div className='d-block flex-full pl-70 sm-pl-0'>
                  <div className='flex-full d-flex justify-content-end'>
                    <div className='betting-reset d-center float-right cursor-point sm-mt-30' onClick={() => onReset(0)}>
                      <img className='' src={'/assets/image/reset.png'} alt='' />
                      <div className='fs-14 f-b color-3a3335 pl-10'>{strings.betting_line_reset}</div>
                    </div>
                  </div>
                  <div className='flex-full d-center mt-8'>
                    <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_gain_rate}</div>
                    <div className='fs-16 sm-fs-14 color-e45a5a flex-full text-right'>{string.Format(strings.format_pro, expectGainRate)}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='v-sub-power fs-18 sm-fs-16 f-b color-3a3335 mt-12 sm-mt-15 ph-10 cursor-point' onClick={() => changeSub(!isSub)}>
            <img className='mr-10' src={!isSub ? '/assets/image/plus2.png' : '/assets/image/close.png'} alt='' width={20} />
            {!isSub ? strings.add_sub_power : strings.del_sub_power}
          </div>
          {isSub &&
          <React.Fragment>
            <div className='al-header mt-12 sm-mt-15 fs-18 sm-fs-16 f-b'>{strings.sub_power}</div>
            <div className='al-content al-content-betting'>
              <label className='control-label sm-ph-15'>{strings.analyst_content}<span className='text-danger'>*</span></label>
              {(data && data.other_purchased == 1) && <div className='bj-note mb-20 fs-16 sm-fs-14' dangerouslySetInnerHTML={{ __html: data.dat_note2 }} />}
              <div className={'sm-ph-15'}>
                <CKEditor
                  editor={ClassicEditor}
                  data={content2}
                  config={{
                    ckfinder: {
                      uploadUrl: API_URL + '/api/upload/upload_file'
                    },
                    placeholder: strings.data_new_input
                  }}
                  onChange={(event, editor) => {
                    setContent2(editor.getData())
                  }}
                />
              </div>
              <div className={'data-filter-area d-flex mt-12 sm-mt-15 pl-40 sm-pl-18'}>
                <select disabled={data && data.other_purchased == 1} className='data-filter-select pr-60 sm-pr-8 fs-16 sm-fs-14 f-sb' value={kind2} onChange={(e) => {setKind2(e.target.value); initData(year, round, e.target.value, 0)}}>
                  {kindList.map((it, idx) => {return (<option value={it.sk_id} key={idx}>{it.sk_name}</option>)})}
                </select>
              </div>
              <div className='analyst_register bd-0 pt-20 sm-pt-40 sm-ph-15'>
                <div className='shadow-div position-relative'>
                  <PerfectScrollbar className='div_sale div_game'>
                    <TableHeaderBetting className={''} headers={tbHeaders}/>
                    {
                      bettingDataList2.map((info, index) => {
                        return (
                          <div key={index} className={'tb-row-betting tb-row-betting1' + (info.disable ? ' tb-row-disabled' : '')}>
                            <TableCell
                              value={info.btm_match_seq}
                              className={tbHeaders[0].class + ' td-cell-primary'}
                              center={tbHeaders[0].center}
                              child={null}
                            />
                            <TableCell
                              value={customDateFormat(info.round_start)}
                              className={tbHeaders[1].class + ' td-cell-primary'}
                              center={tbHeaders[1].center}
                              child={null}
                            />
                            <TableCell
                              value={info.league_name}
                              className={tbHeaders[2].class + ' td-cell-primary'}
                              center={tbHeaders[2].center}
                              child={null}
                            />
                            <TableCellBettingResult
                              betting_type={info.betting_type}
                              home={info.home_name}
                              away={info.away_name}
                              winScore={info.home_dividend_rate}
                              winUp={info.prev_home_dividend_rate}
                              loseScore={info.away_dividend_rate}
                              loseUp={info.prev_away_dividend_rate}
                              drawScore={info.no_odds}
                              drawUp={info.prev_no_odds}
                              handi={info.handicap_standard}
                              uo={info.uo_standard}
                              selected={info.sel}
                              ans={-1}
                              className={tbHeaders[3].class + ' td-cell-primary'}
                              center={tbHeaders[3].center}
                              child={null}
                              onSelectChange={(val) => {
                                onSelChange(val, index, 1)
                              }}
                            />
                            <TableCell
                              value={''}
                              className={tbHeaders[4].class + ' td-cell-primary'}
                              center={tbHeaders[4].center}
                              child={null}
                            />
                          </div>
                        )
                      })
                    }
                  </PerfectScrollbar>
                </div>
                <div className='div-betting-info d-flex-block pv-48 sm-pv-20 ph-20 sm-ph-30 align-items-center'>
                  <div className='d-block flex-full'>
                    <div className='flex-full d-center'>
                      <div className='fs-16 sm-fs-14 f-sb color-3a3335'>{strings.selected_game_count}</div>
                      <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_game_count, selGameCnt2)}</div>
                    </div>
                    <div className='flex-full d-center mt-8'>
                      <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_rate}</div>
                      <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_rate, expectRate2)}</div>
                    </div>
                  </div>
                  <div className='d-block flex-full pl-70 sm-pl-0 sm-mt-30'>
                    <div className='flex-full f-sb d-flex align-items-center'>
                      <div className='fs-16 sm-fs-14 color-3a3335 flex-full'>{strings.betting_amount}</div>
                      <AppInput disable={data && data.other_purchased == 1} center={true} className={'betting-price-input fs-16 sm-fs-14'} errorMsg={''} placeholder={'10,000'} inputType={'text'} value={bettingAmount2.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} onChange={(v) => { updateBetting(v, 1) }} />
                      <div className='fs-16 sm-fs-14 f-b color-e45a5a pl-12'>{strings.won}</div>
                    </div>
                    <div className='flex-full d-center mt-8 sm-mt-5'>
                      <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_amount}</div>
                      <div className='fs-16 sm-fs-14 f-b color-e45a5a flex-full text-right'>{string.Format(strings.format_won, formatNumber(expectCoin2))}</div>
                    </div>
                  </div>
                  <div className='d-block flex-full pl-70 sm-pl-0'>
                    <div className='flex-full d-flex justify-content-end'>
                      <div className='betting-reset d-center float-right cursor-point sm-mt-30' onClick={() => onReset(1)}>
                        <img className='' src={'/assets/image/reset.png'} alt='' />
                        <div className='fs-14 f-b color-3a3335 pl-10'>{strings.betting_line_reset}</div>
                      </div>
                    </div>
                    <div className='flex-full d-center mt-8'>
                      <div className='fs-16 sm-fs-14 color-3a3335 f-b'>{strings.expectant_gain_rate}</div>
                      <div className='fs-16 sm-fs-14 color-e45a5a flex-full text-right'>{string.Format(strings.format_pro, expectGainRate2)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
          }
          <ConfirmButton enabled={enabled} className={'btn btn-login mt-60 sm-mt-30 fs-15 sm-fs-14 f-m '} onClick={() => onSave()} text={data ? strings.do_modify : strings.make} />
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(AnalystNewBetting)
